import React, { useContext } from "react";
import { Suspense } from "react";
import { store } from "../../redux/store";
import { useParams } from "react-router-dom";
import './Chat.scss'
import { ErrorBoundary } from "../Common/ErrorBoundry";
import { IUserProfile } from "../../types/User/IUserProfile";
import { RevUserContext, RevUserContextType } from "../../context/UserContext";

//@ts-expect-error
const ChatRequestModule = React.lazy(() => import("chat/ChatRequest"));

export default function ChatRequest() {
    const { profile } = React.useContext<RevUserContextType>(RevUserContext)
    //Chat request is for external people only
    if (!profile?.Features?.SSIChat)
        return <></>

    return (
        <ErrorBoundary>
            <div className="chat-request">
                <Suspense fallback={'Loading...'}>
                    <ChatRequestModule />
                </Suspense>
            </div>
        </ErrorBoundary>
    )
}
